import { history, request } from '@umijs/max';
import { stringify } from 'querystring';

export const authService = {
  fetchTwitchToken: async (code: string, options?: { [key: string]: any }) => {
    const response = await request<API.Service.TokenRes>(
      `/auth/token?code=${code}`,
      {
        method: 'GET',
        headers: {
          isToken: false,
          'Content-Type': 'application/json',
        },
        ...(options || {}),
      },
    );

    return response;
  },

  handleLogout: () => {
    localStorage.removeItem('bearer');
    localStorage.removeItem('refresh');
    localStorage.removeItem('expiry');
    localStorage.removeItem('twitch');
  },

  loginOut: async () => {
    //await signOut(auth);
    authService.handleLogout();
    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect');
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/' && !redirect) {
      history.replace({
        pathname: '/',
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
  },
};

export default authService;

export const getLoginPath = (redirectUrl?: string) => {
  const client_id = process.env.TWITCH_CLIENT_ID;
  const twichRedirect = process.env.TWITCH_REDIRECT_URI;
  const redirect_uri = redirectUrl
    ? `${twichRedirect}${redirectUrl}`
    : twichRedirect;

  const response_type = 'code';
  const scopes = ['chat', 'edit+chat', 'read+openid'];
  const scope = scopes.reduce((s1, s2) => s1 + ':' + s2);
  const params = `client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}`;
  const url = `https://id.twitch.tv/oauth2/authorize?${params}`;

  return { url: url };
};
